import AddCircleIcon from '@mui/icons-material/AddCircle';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const verifiedTagStyle = {
  box: { display: 'flex', flexDirection: 'row', gap: 0.5, alignItems: 'center' },
  icon: { height: '20px', width: '20px' },
};

const ListingCardTagPlus = () => {
  return (
    <Box sx={verifiedTagStyle.box}>
      <AddCircleIcon sx={verifiedTagStyle.icon} />
      <Typography color="#fff" lineHeight={1} margin={0} variant="small">
        <FormattedMessage id="ListingCard.plus" />
      </Typography>
    </Box>
  );
};

export default ListingCardTagPlus;
